import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { User } from "@ecologi/shared";
import { Button } from "../Button";
import { Text } from "../Text";
import { Wrapper } from "../Wrapper";
import { useBodyClass } from "../utils";

type Props = {
  user: User;
};

export const CtaWrapper = styled.div`
  margin-top: 40px;
`;

export const Hand = styled.div`
  font-size: 90px;
  line-height: 90px;
  margin-bottom: 20px;
  padding-top: 40px;
`;

export const Or = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 15px 0;
  opacity: 0.9;
  text-align: center;
`;

export const Mountains = styled.div`
  background-image: url(/images/app/mountains-background.svg);
  background-position: top;
  background-repeat: repeat-x;
  background-size: 1600px;
  bottom: 0;
  height: 320px;
  width: 100%;
`;

export const YoureAwesome: React.FC<Props> = ({ user }) => {
  useBodyClass("bodyMountains");

  return (
    <Fragment>
      <Wrapper style={{ textAlign: "center" }}>
        <Hand>
          <span role="img" aria-label="Fist emoji">
            ✊
          </span>
        </Hand>
        <Text
          isHeading
          style={{ marginBottom: "8px" }}
          text="You’re already a member"
        />
        <Text
          isSubheading
          style={{ marginBottom: "25px" }}
          text={`You already have an active ${
            user.subscription ? "subscription" : "account"
          }. If you want to view this page, please log out.`}
        />
        <CtaWrapper>
          <Button
            href={`/${user.username}`}
            primary
            text="Go to your profile"
          />
          <Or>Or</Or>
          <Button
            green
            onClick={async (e) => {
              e.preventDefault();
              window.location.href = "/auth/logout";
            }}
            text="Log out"
          />
        </CtaWrapper>
      </Wrapper>
      <Mountains />
    </Fragment>
  );
};
